<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>模拟配置</span>
      </div>

      <el-form>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="用户分组" class="mtop">
              <el-select v-model="basic.group" placeholder="请选择">
                <el-option
                  v-for="item in group"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="测试用户数">
              <el-input v-model.number="basic.initUser" placeholder="测试用户数" />
            </el-form-item>
          </el-col>

        </el-row>

        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="初始等级">
              <el-input v-model.number="basic.initLevel" placeholder="初始等级" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="初始体力">
              <el-input v-model.number="basic.initSpins" placeholder="初始体力" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="初始金币">
              <el-input v-model.number="basic.initMoney" placeholder="初始金币" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="bet" class="mtop">
              <el-select v-model="basic.bet" placeholder="请选择">
                <el-option
                  v-for="item in betArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="每天新增体力">
              <el-input v-model.number="basic.daySpins" placeholder="每天新增体力" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="开始时间">
              <el-date-picker
                v-model="basic.time.start"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="结束时间">
              <el-date-picker
                v-model="basic.time.end"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="测试功能">
              <el-checkbox-group v-model="checkList">
                <el-checkbox label="棋盘走格子" disabled />
                <el-checkbox label="在线活动礼包" disabled />
                <el-checkbox label="每日签到" disabled />
                <el-checkbox label="每日任务" disabled />
                <el-checkbox label="能力升级" disabled />
                <el-checkbox label="关卡制作" disabled />
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="输出配置">
              <el-checkbox-group v-model="outCheckList">
                <el-checkbox label="消耗体力" disabled />
                <el-checkbox label="消耗金币" disabled />
                <el-checkbox label="玩家等级" disabled />
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item>
              <el-switch
                v-model="basic.status"
                style="display: block"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="运行中"
                inactive-text="关闭"
                @change="switchStatus"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item>
              <el-button :disabled="basic.status ===true" type="primary" @click="onSubmit()">保存</el-button>
              <el-button :disabled="basic.status ===true" type="danger" @click="reset()">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getBetConfig, getCommonCfg, resetBotList, updateCommonCfg } from '@/api/config/common-cfg'
import { getUserTypeList } from '@/api/config/user-group-cfg'

export default {
  name: 'Basic',
  data() {
    return {
      checkList: [
        '棋盘走格子',
        '在线活动礼包',
        '每日签到',
        '每日任务',
        '能力升级',
        '关卡制作'
      ],
      outCheckList: [
        '消耗体力',
        '消耗金币',
        '玩家等级'
      ],
      betArr: [],
      group: [],
      key: 'BOTANALOG:BASIC',
      basic: {
        group: 0,
        initUser: 0,
        initLevel: 0,
        initSpins: 0,
        initMoney: 0,
        bet: 0,
        daySpins: 0,
        time: {
          start: '',
          end: ''
        },
        status: false,
        reset: true
      }
    }
  },
  created() {
    this.getGroupList()
    this.getBetCfg()
    this.getTables()
  },
  methods: {
    reset() {
      this.$confirm('此操作将清理机器人数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        resetBotList().then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    switchStatus(value) {
      this.onSubmit()
    },
    getTables() {
      getCommonCfg({ name: this.key }).then(res => {
        this.basic = res.data
      })
    },
    getBetCfg() {
      getBetConfig().then(res => {
        this.betArr = []
        res.data.forEach(item => {
          this.betArr.push({ label: '下注' + item, value: item })
        })
      })
    },
    getGroupList() {
      getUserTypeList({ pageSize: 1000 }).then(res => {
        this.group = []
        res.data.list.forEach(item => {
          this.group.push({ label: item.name, value: item.groupId })
        })
      })
    },
    onSubmit() {
      if (this.basic.time.start > this.basic.time.end) {
        this.msgError('开始时间不能大于结束时间')
        return
      }
      const data = JSON.stringify(this.basic)
      updateCommonCfg({ data: data, name: this.key }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.mtop{
  margin-top: 35px
}
</style>
